var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-nav-toggle light d-lg-none",on:{"click":_vm.toggleMenu}},[_c('span',{staticClass:"toggle-bar"}),_c('span',{staticClass:"toggle-bar"}),_c('span',{staticClass:"toggle-bar"})])}
var staticRenderFns = []

export { render, staticRenderFns }